import React from "react";
import { useConsent } from "@/context/ConsentContext";

// Ad slot for Google Adsense. Only renders ads when advertising consent is granted.
export default function AdSlot({ format = "leaderboard", className = "" }) {
  const { prefs, openManager } = useConsent();
  const sizes = { leaderboard: "h-24 md:h-28", rectangle: "h-64", mobile: "h-20" };
  const base = `w-full ${sizes[format] || sizes.leaderboard} rounded-xl border border-dashed flex items-center justify-center ${className}`;

  if (!prefs.advertising) {
    return (
      <div className={`${base} border-olive/25 bg-olive/5`} data-testid={`ad-slot-${format}-disabled`} aria-hidden>
        <button onClick={openManager} className="text-[11px] uppercase tracking-[0.25em] text-charcoal/40 hover:text-olive-dark transition-colors">
          Pubblicità disattivata · gestisci cookie
        </button>
      </div>
    );
  }

  return (
    <div className={`${base} border-rose-200 bg-surface`} data-testid={`ad-slot-${format}`} aria-hidden>
      <span className="text-[10px] uppercase tracking-[0.3em] text-charcoal/30">Advertisement</span>
    </div>
  );
}
